<template>
    <div class="column-selector">
        <div class="columns-container">
            <div class="column-group">
                <h3 class="column-title">{{ $t("ticket.ticketField") }}</h3>
                <div class="fields-scroll-container">
                    <div v-for="field in selectableColumns" :key="field.key" class="field-item">
                        <a-switch v-model="localSelectedColumns[field.key]" class="custom-switch" />
                        <span class="field-label">{{ field.label }}</span>
                    </div>
                </div>
            </div>
            
            <div class="vertical-divider"></div>
            
            <div class="column-group">
                <h3 class="column-title">{{ $t("ticket.contactPropertyFields") }}</h3>
                <div class="fields-scroll-container">
                    <div v-for="field in contactPropertyFields" :key="field.key" class="field-item">
                        <a-switch v-model="localSelectedColumns[field.key]" class="custom-switch" />
                        <span class="field-label">{{ field.label }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="actions">
            <a-button @click="cancel">{{ $t("wp.cancel") }}</a-button>
            <a-button type="primary" @click="save">{{ $t("ticket.save") }}</a-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ColumnSelector",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        ticketFields: {
            type: Array,
            default: () => [],
        },
        contactPropertyFields: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            localSelectedColumns: {},
        };
    },
    computed: {
        selectableColumns() {
            return this.ticketFields.filter(field => !['checkbox', '_id'].includes(field.key));
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.localSelectedColumns = {};
                val.forEach((key) => {
                    this.$set(this.localSelectedColumns, key, true);
                });
            },
        },
    },
    methods: {
        save() {
            const selectedKeys = Object.keys(this.localSelectedColumns).filter((key) => this.localSelectedColumns[key]);
            this.$emit("input", selectedKeys);
            this.$emit("save");
        },
        cancel() {
            this.$emit("cancel");
        },
    },
};
</script>

<style lang="scss" scoped>
.column-selector {
    display: flex;
    flex-direction: column;
    max-height: 80vh;
    min-height: 400px;
    
    .columns-container {
        display: flex;
        flex: 1;
        gap: 20px;
        height: 100%;
    }

    .column-group {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 250px;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
    }

    .column-title {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 16px;
        color: #2d3748;
        padding: 0 8px;
    }

    .fields-scroll-container {
        height: 400px;
        flex: unset;
        overflow-y: auto;
        padding: 0 8px;
        
        &::-webkit-scrollbar {
            width: 6px;
        }
        
        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
        }
        
        &::-webkit-scrollbar-thumb {
            background: #cbd5e0;
            border-radius: 3px;
            
            &:hover {
                background: #a0aec0;
            }
        }
    }

    .field-item {
        display: flex;
        align-items: center;
        padding: 10px;
        margin-bottom: 8px;
        background: white;
        border-radius: 6px;
        transition: all 0.2s ease;
        
        &:hover {
            background: #edf2f7;
        }

        .field-label {
            margin-left: 12px;
            font-size: 14px;
            color: #4a5568;
        }
    }

    .vertical-divider {
        width: 1px;
        background-color: #e2e8f0;
        margin: 16px 0;
    }

    .actions {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        padding: 16px;
        border-top: 1px solid #e2e8f0;
    }
}

:deep(.custom-switch) {
    &.ant-switch-checked {
        background-color: #4a5568;
    }
}
</style>
